function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.624 33.5601V15.0801H50.8143V18.4401H41.0805V23.4801H50.2978V26.7201H41.0805V33.5601H37.624Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.8601 33.5601V15.0801H59.2769V33.5601H55.8601Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.4459 33.56H77.314L71.9505 27.4H68.6132V33.56H65.1567V15.04C68.057 15.04 70.997 15.08 73.8973 15.08C78.2675 15.08 80.5321 18 80.5321 21.2C80.5321 23.72 79.38 26.28 75.8838 27L81.4459 33.32V33.56ZM68.653 18.32V24.24H73.937C76.1221 24.24 77.0757 22.76 77.0757 21.28C77.0757 19.8 76.1221 18.32 73.937 18.32H68.653Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.8212 19.5201C96.1855 18.4801 94.4772 17.4801 92.4509 17.4801C89.8685 17.4801 88.6369 18.5601 88.6369 19.9201C88.6369 21.5201 90.5439 21.9601 92.7291 22.2401C96.5431 22.7201 100.119 23.7201 100.119 28.1201C100.119 32.2401 96.5034 34.0001 92.4112 34.0001C88.6766 34.0001 85.7763 32.8401 84.4255 29.4401L87.3258 27.9201C88.1204 29.9601 90.2658 30.8401 92.4907 30.8401C94.6758 30.8401 96.702 30.0801 96.702 28.0801C96.702 26.3201 94.8745 25.6401 92.4509 25.3601C88.7163 24.9201 85.2599 23.9201 85.2599 19.7601C85.2599 15.9601 88.9945 14.4001 92.3715 14.3601C95.232 14.3601 98.2118 15.1601 99.5626 18.0401L96.8212 19.5201Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.21 18.2401H104.37V15.0801C109.654 15.0801 114.143 15.0801 119.467 15.0801V18.2401H113.627V33.5601H110.17V18.2401H110.21Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.632 33.5601V15.0801H126.023V33.5601H124.632Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.293 15.0801L145.649 30.3601V15.0801H147.04V33.5601H146.483L134.128 18.3201V33.5601H132.697V15.0801H133.293Z",
  fill: "#15232B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.0095 11.6C28.0095 11.28 27.9698 10.92 27.8904 10.64C27.8506 9.48 28.1685 7.76 30.4728 7.84C30.8304 7.96 31.1879 8 31.5852 8C33.7704 8 35.5582 6.2 35.5582 4C35.5582 1.8 33.7704 0 31.5852 0C29.4001 0 27.6122 1.8 27.6122 4C27.6122 4.4 27.652 4.76 27.7712 5.12C27.7314 6.16 27.0163 7.6 23.6393 7.6H4.1717C1.98657 7.6 0.19873 9.4 0.19873 11.6C0.19873 15.04 2.97981 15.6 2.97981 15.6C4.09224 15.6 4.9663 16.48 4.9663 17.6C4.9663 18.72 4.09224 19.6 2.97981 19.6C2.97981 19.6 0.19873 20.08 0.19873 23.6C0.19873 25.8 1.98657 27.6 4.1717 27.6H16.0906C18.2758 27.6 20.0636 25.8 20.0636 23.6C20.0636 21.4 18.2758 19.6 16.0906 19.6H8.93927C7.82684 19.6 6.95279 18.72 6.95279 17.6C6.95279 16.48 7.82684 15.6 8.93927 15.6H24.0366C26.2217 15.6 28.0095 13.8 28.0095 11.6ZM5.76089 31.6C3.57576 31.6 1.78792 33.4 1.78792 35.6C1.78792 37.8 3.57576 39.6 5.76089 39.6C7.94603 39.6 9.73387 37.8 9.73387 35.6C9.73387 33.4 7.94603 31.6 5.76089 31.6Z",
  fill: "url(#paint0_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 17.8785,
  y1: 39.6,
  x2: 17.8785,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DA3F80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B01BAE"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 147,
  height: 40,
  fill: "white"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 40,
    viewBox: "0 0 147 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.652bf19f.svg";
export { ForwardRef as ReactComponent };